const API_BASE_URL = process.env.VUE_APP_API_URL;
const ENABLE_MOBILE_SITE = process.env.VUE_APP_ENABLE_MOBILE_SITE;
const TITLE = process.env.VUE_APP_TITLE;
const TEIKI_HIKAKU = process.env.VUE_APP_TEIKI_HIKAKU;
const DEBUG_MODE = process.env.VUE_APP_DEBUG_MODE;
const IS_USER_PAGE = process.env.VUE_APP_IS_USER_PAGE;

export default {
  API_BASE_URL: API_BASE_URL,
  ENABLE_MOBILE_SITE: ENABLE_MOBILE_SITE,
  TITLE: TITLE,
  TEIKI_HIKAKU: TEIKI_HIKAKU,
  DEBUG_MODE: DEBUG_MODE,
  IS_USER_PAGE: IS_USER_PAGE,
};
